import { useState } from "react";
import { BEST_SELLERS } from "../data/products";
import ProductCard from "./ProductCard";
import ProductQuickView from "./ProductQuickView";

const BestSellers = () => {
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (p) => {
    setActive(p);
    setOpen(true);
  };

  return (
    <section
      id="best-sellers"
      data-testid="best-sellers"
      className="py-20 md:py-28 bg-[hsl(var(--sand))]/40"
    >
      <div className="container-tjb">
        <div className="flex items-end justify-between gap-6 mb-10">
          <div>
            <p className="eyebrow">Most Loved</p>
            <h2 className="h-section mt-3">Best Sellers</h2>
          </div>
          <p className="hidden md:block max-w-sm text-sm text-[hsl(var(--muted-foreground))]">
            Five favourites our Canggu and Ubud customers come back for — the
            essential linen wardrobe.
          </p>
        </div>

        {/* Mobile: horizontal scroll | Desktop: 5-col grid */}
        <div
          className="-mx-5 px-5 scroll-row md:mx-0 md:px-0 md:overflow-visible md:grid md:grid-cols-2 lg:grid-cols-5 md:gap-6 lg:gap-7 md:snap-none"
          data-testid="best-sellers-grid"
        >
          {BEST_SELLERS.map((p, i) => (
            <div
              key={p.id}
              className="snap-start shrink-0 w-[78%] xs:w-[70%] md:w-auto md:h-full"
            >
              <ProductCard product={p} onOpen={handleOpen} idx={i} prefix="bs" />
            </div>
          ))}
        </div>
      </div>

      <ProductQuickView product={active} open={open} onOpenChange={setOpen} />
    </section>
  );
};

export default BestSellers;
